import { render, staticRenderFns } from "./ApprovalMonthly.vue?vue&type=template&id=0a72240f&scoped=true&"
import script from "./ApprovalMonthly.vue?vue&type=script&lang=js&"
export * from "./ApprovalMonthly.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=0a72240f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72240f",
  null
  
)

export default component.exports